import './App.scss';
import Header from "./components/Header";

import {pdfjs} from "react-pdf";
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import {UrlHelper} from "./components/utils/UrlHelper";
import * as React from "react";
import {useCallback, useEffect, useState} from "react";
import {Configuration, ConfigurationParameters, DamMediaCenterApiApi, MediaCenter} from "./api";
import Footer from "./components/Footer";
import {Route, Routes} from 'react-router-dom';
import {Spinner} from "./components/Spinner";
import {AssetsPage} from "./components/pages/AssetsPage";
import {NotFoundPage} from "./components/pages/NotFoundPage";
import {LoginCallback, useOktaAuth} from "@okta/okta-react";
import {NotAuthorizedPage} from "./components/pages/NotAuthorizedPage";
import {toRelativeUrl} from "@okta/okta-auth-js";
import {LoginPage} from './components/pages/LoginPage';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

export const URL_HELPER = new UrlHelper();

function App() {
    const [mediaCenterLoaded, setMediaCenterLoaded] = useState<boolean>(false);
    const [notAuthorized, setNotAuthorized] = useState<boolean>(false);
    const [mediaCenter, setMediaCenter] = useState<MediaCenter | undefined>();
    const [mediaCenterApi, setMediaCenterApi] = useState<DamMediaCenterApiApi>();

    const {oktaAuth, authState} = useOktaAuth();

    const handleSecure = useCallback(() => {
        const previousAuthState = oktaAuth.authStateManager.getPreviousAuthState();
        if (!previousAuthState || !previousAuthState.isAuthenticated) {
            localStorage.setItem("media-center.login-success-url", window.location.href);
            window.location.replace(toRelativeUrl("/login", window.location.origin));
        }
    }, [oktaAuth]);

    useEffect(() => {
        if (authState) {
            const config: ConfigurationParameters = {
                basePath: URL_HELPER.getApiUrl()
            };

            if (authState.isAuthenticated && authState?.accessToken?.accessToken) {
                config.headers = {Authorization: `Bearer ${authState?.accessToken?.accessToken}`};
            }

            setMediaCenterApi(new DamMediaCenterApiApi(new Configuration(config)));
        }
        // eslint-disable-next-line
    }, [authState]);

    useEffect(() => {
        if (!mediaCenterLoaded && mediaCenterApi) {
            mediaCenterApi.getMediaCenter({
                mediaCenterId: URL_HELPER.getMediaCenterId()
            })
                .then(data => {
                    setMediaCenter(data);
                    setMediaCenterLoaded(true);
                })
                .catch(async (reason) => {
                    if (reason.status) {
                        switch (reason.status) {
                            case 401:
                                handleSecure();
                                break;
                            case 403:
                                setNotAuthorized(true);
                                setMediaCenterLoaded(true);
                                break;
                            case 404:
                                setMediaCenterLoaded(true);
                                break;
                        }
                    }
                });
        }
    }, [mediaCenterApi, handleSecure]);

    function renderContent() {
        if (mediaCenterLoaded) {
            if (mediaCenter) {
                return <AssetsPage api={mediaCenterApi}/>;
            } else if (notAuthorized) {
                return <NotAuthorizedPage/>;
            }
            return <NotFoundPage/>;
        } else {
            return <div className="text-center py-4">
                <Spinner/>
            </div>;
        }
    }

    return (
        <div className="portal-app">
            <Header mediaCenter={mediaCenter}/>
            <main>
                <Routes>
                    <Route path="/login" element={<LoginPage/>}/>
                    <Route path="/login-success" element={<LoginCallback errorComponent={NotAuthorizedPage}/>}/>
                    <Route path="/" element={<></>}/>
                    <Route path="*" element={renderContent()}/>
                </Routes>
            </main>
            <Footer/>
        </div>
    );
}

export default App;
